import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function paginationCurrentNavigation(theme: Theme): ComponentStyle {
  return {
    componentName: 'paginationCurrentNavigation',
    baseStyle: {
      color: theme.colors.muted
    }
  };
}
